import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-tdo-subnav',
  templateUrl: './tdo-subnav.component.html',
  styleUrls: ['./tdo-subnav.component.scss']
})
export class TdoSubnavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
